import {
  GetAdminApplicationComponentResponse,
  GetAppMenuButtonsResponse,
  GetCardResponse,
  GetSMTPResponse,
} from '@/services/response/admin-config';
import { AppMenuButton, ConfigCard, ConfigSMTP } from '@/model';
import { ApplicationComponent } from '@/model/application-component';

export class AdminConfigConverter {
  // Método para converter GetSMTPResponse em ConfigSMTP
  static toConfigSMTPFromByGetSMTPResponse(response: GetSMTPResponse): ConfigSMTP {
    return {
      from: response.from,
      host: response.host,
      port: response.port,
      username: response.username,
      reply_to: response.reply_to,
    };
  }

  // Método para converter GetCardResponse em ConfigCard
  static toConfigCardFromGetCardResponse(response: GetCardResponse): ConfigCard {
    return {
      bg_type: response.bg_type,
      bg_color: response.bg_color,
      bg_image: response.bg_image,
      icon_image: response.icon_image,
      title_common: response.title_common,
      title_subscriber: response.title_subscriber,
    };
  }

  static toDomainFromGetAdminApplicationComponentResponse(
    response: GetAdminApplicationComponentResponse,
  ): ApplicationComponent[] {
    return response.components?.map(item => ({
      component_id: item.component_id,
      active: item.active,
      parent_id: item.parent_id,
      properties: item.properties,
    }));
  }

  static toDomainAppMenuButton(response: GetAppMenuButtonsResponse): { available: AppMenuButton[]; active: AppMenuButton[] } {
    return {
      available: response.available,
      active: response.active,
    };
  }
}
